import React from 'react';
import './index.scss';

interface IChildHeadProps {
  title: string;
  subtitle?: string;
  rightText?: any;
  showSearch?: boolean;
  callback?: () => void;
  underline?: boolean;
  disableHandleBtn?: boolean;
}

const ChildHead: React.FC<IChildHeadProps> = (props) => {
  const { underline = true, disableHandleBtn = false } = props;
  return (
    <div className={`${underline && 'underline'} child-head`}>
      <div className="child-title">
        <span>{props.title}</span>
        <span>{props.subtitle}</span>
      </div>
      <div className="handles">
        {/* 按钮 */}
        {props.rightText && (
          <div className={`handle ${disableHandleBtn && 'disabled'}`} onClick={() => (props.callback ? props.callback() : '')}>
            {/* {props.rightText} */}
            <div dangerouslySetInnerHTML={{ __html: props.rightText }}></div>
          </div>
        )}
        {/* 搜索 */}
      </div>
    </div>
  );
};

export default ChildHead;
